import Dialog from "@material-ui/core/Dialog";
import React, { useEffect, useState } from "react";
//import Box from "@material-ui/core/Box";
import DialogContent from "@material-ui/core/DialogContent";
import Paper from "@material-ui/core/Paper";

import { Formik } from "formik";
//import TextField from "@material-ui/core/TextField";

//import FormControl from "@mui/material/FormControl";
//import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import {
    clienteAlgoritimoDropDown
} from "../../../services/ClienteAlgoritimoService";


import {
    createMuiTheme,
    makeStyles,
    ThemeProvider,
} from "@material-ui/core/styles";

import {
    DataGrid,
    GridFilterToolbarButton,
    GridToolbarContainer,
    ptBR,
} from "@material-ui/data-grid";

//import TextField from "@material-ui/core/TextField";


import CloseIcon from "@material-ui/icons/Close";

import {
    usuarioxclienteDelete,
    usuarioxclienteFindAllById,
    usuarioxclienteInsert,
    usuarioxclienteUpdate,
} from "../../../services/UsuarioxclienteService";

import {
    clienteFindAll
} from "../../../services/ClienteService";

import {
    getClienteLocal
} from "../../../services/ClienteLocalService";

import {
    ButtonCancel,
    ButtonDelete,
    ButtonSave
} from "../../botoes/operacao";

import { Loading } from "../../Loading";
import { ShowMessageBox } from "../../ShowMessageBox";

const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        "flex-direction": "row",
        "justify-content": "center",
        marginLeft: "2rem",
        alignItems: "center",

        height: "75vh",
        width: "95%",
        backgroundColor: "transparent",
    },
    boxPrancheta: {
        backgroundColor: "white",
        height: "90%",
        width: "90%",
        //'border': '5px solid blue',
        display: "flex",
    },
    boxDataGrid: {
        "& .header_grid": {
            backgroundColor: "#2471A3",
            color: "white",
        },
        height: "90%",
        width: "450px",
        "& .MuiDataGrid-row.Mui-even:not(:hover)": {
            backgroundColor: "#D6EAF8",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-odd:not(:hover)": {
            backgroundColor: "#AED6F1",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-selected:not(:hover)": {
            backgroundColor: "#999999",

            color: "white",
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row:hover": {
            backgroundColor: "#D3D3D3",
            color: "black",
        },
    },
    side_content: {
        /*        'background-color': '#cce0ff',*/
        /*        'border': 'solid 1px #0052cc',*/
        display: "grid",
        overflow: "auto",
    },
    nome: {
        width: "400px",
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        paddingTop: "100px",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

let severity = "success";
let msg = "";
let inserir = true;

const theme = createMuiTheme(
    ptBR
);

export default function DialogoCliente({ isOpened, closeDialog, usuario }) {

    const classes = useStyles();
    const [usuarioxcliente, setUsuarioxcliente] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [clientesLocal, setClientesLocal] = useState([]);
    const [listClienteAlgoritimo, setListClienteAlgoritimo] = React.useState([]);

    const [loading, setLoading] = useState(false);
    const [snackBar, setSnackBar] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState({});

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridFilterToolbarButton />
            </GridToolbarContainer>
        );
    };

    useEffect(async () => {
        setLoading(true);
        try {
            const respUsuarioxCliente = await usuarioxclienteFindAllById(usuario.usu_id);
            const respClientes = await clienteFindAll();
            const respAlgoritimo = await clienteAlgoritimoDropDown();

            setUsuarioxcliente(respUsuarioxCliente.data);
            setClientes(respClientes.data);
            setListClienteAlgoritimo(respAlgoritimo.data);
        } catch (error) {
            setUsuarioxcliente([]);
        }
        inserir = true;
        setLoading(false);
    }, []);


    const deleteRecord = async () => {
        setLoading(true);
        try {
            await usuarioxclienteDelete(usuario.usu_id, selectedRow.cli_id, selectedRow.loc_id);
            const respCliente = await usuarioxclienteFindAllById(usuario.usu_id);
            setUsuarioxcliente(respCliente.data);
            msg = "Ligação do usuario para cliente excluída com sucesso";
            severity = "success";
            setSnackBar(true);
            setLoading(false);
            cancelRecord();
        } catch (error) {
            msg = "Erro ao excluir ligação do usuario para cliente ";
            severity = "error";
            setSnackBar(true);
            setLoading(false);
        }
    }

    const cancelRecord = () => {
        setSelectedRow({});
        inserir = true;
    }

    //console.log("setSelectedRow", selectedRow);

    return (
        <Dialog
            open={isOpened}
            aria-labelledby="form-dialog-title"
            fullWidth
            maxWidth="lg"
            style={{ zIndex: 1000 }}
        >
            <div
                id="form-dialog-title"
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingRight: "2rem",
                    paddingLeft: "2rem",
                    alignItems: "center",
                    background: "lightblue",
                    height: "4rem",
                }}
            >
                <span style={{ fontSize: "1.2rem" }}>
                    Usuario: <b>{usuario.usu_nome}</b>
                </span>
                <ButtonCancel
                    variant="contained"
                    color="primary"
                    type="button"
                    style={{
                        padding: "3px",
                        color: "white",
                        fontWeight: "bold",
                    }}
                    onClick={closeDialog}
                >
                    <CloseIcon />
                </ButtonCancel>

            </div>

            <DialogContent>
                <Loading open={loading} />
                <ShowMessageBox
                    open={snackBar}
                    setOpen={setSnackBar}
                    severity={severity}
                    msg={msg}
                />
                <div className={classes.box}>
                    <Paper className={classes.boxPrancheta} elevation={7}>
                        <div style={{ flexGrow: 1, padding: '10px' }}>
                            <div className={classes.boxDataGrid}>
                                <ThemeProvider theme={theme}>
                                    <DataGrid
                                        rows={usuarioxcliente}
                                        disableColumnMenu
                                        disableColumnReorder
                                        id="loc_id"
                                        spacing={0}
                                        direction="column"
                                        headerAlign="center"
                                        rowHeight={50}
                                        pageSize={15}
                                        onRowSelected={async (newSelection) => {
                                            //console.log("newSelection", newSelection)
                                            setSelectedRow(newSelection.data);
                                            const respClienteLocal = await getClienteLocal(newSelection.data.cli_id);
                                            setClientesLocal(respClienteLocal.data);
                                            inserir = false;
                                        }}
                                        components={{
                                            Toolbar: CustomToolbar,
                                        }}
                                        columns={[
                                            {
                                                field: "cli_apelido",
                                                headerName: "Cliente",
                                                headerClassName: "header_grid",
                                                align: "center",
                                                type: "string",
                                                headerAlign: "center",
                                                flex: 1,
                                                sortable: false,
                                            },
                                            {
                                                field: "loc_nome",
                                                headerName: "Localidade",
                                                headerClassName: "header_grid",
                                                align: "center",
                                                type: "string",
                                                headerAlign: "center",
                                                flex: 1,
                                                sortable: false,
                                            }
                                        ]}
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                        <div style={{ flexGrow: 1, flexDirection: 'column', alignSelf: 'center', padding: '10px' }}>
                            <Formik
                                initialValues={{
                                    cliId: selectedRow.cli_id ? selectedRow.cli_id : "",
                                    locId: selectedRow.loc_id ? selectedRow.loc_id : "",
                                }}
                                enableReinitialize
                                validate={(values) => {
                                    const errors = {};
                                    if (!values.cliId) {
                                        errors.cliId = "Obrigatório";
                                    }
                                    return errors;
                                }}
                                onSubmit={async (values, { setSubmitting }) => {
                                    setSubmitting(true);
                                    setLoading(true);
                                    if (inserir) {
                                        try {
                                            await usuarioxclienteInsert({
                                                usu_id: usuario.usu_id,
                                                cli_id: values.cliId,
                                                loc_id: values.locId === '' ? null : values.locId
                                            });

                                            const respCliente = await usuarioxclienteFindAllById(usuario.usu_id);
                                            setUsuarioxcliente(respCliente.data);
                                            msg = "Cliente incluido com sucesso";
                                            severity = "success";
                                            setSnackBar(true);
                                            setLoading(false);
                                            cancelRecord();
                                        } catch (error) {
                                            msg = "Erro ao inserir cliente";
                                            severity = "error";
                                            setSnackBar(true);
                                            setLoading(false);
                                        }
                                    } else {
                                        if (!values.locId) {
                                            msg = "Para atualizar selecione a localidade";
                                            severity = "error";
                                            //console.log(error);
                                            setSnackBar(true);
                                            setLoading(false);

                                        } else {

                                            try {
                                                await usuarioxclienteUpdate(usuario.usu_id, selectedRow.cli_id, values.locId);

                                                const respCliente = await usuarioxclienteFindAllById(usuario.usu_id);
                                                setUsuarioxcliente(respCliente.data);

                                                msg = "Localidade atualizado com sucesso";
                                                severity = "success";
                                                setSnackBar(true);
                                                setLoading(false);
                                                cancelRecord();
                                            } catch (error) {
                                                msg = "Erro ao atualizar localidade";
                                                severity = "error";
                                                console.log(error);
                                                setSnackBar(true);
                                                setLoading(false);
                                            }
                                        }

                                    }
                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    handleChange,
                                    handleSubmit,
                                    isValid,
                                    setFieldValue
                                }) => (
                                    <form onSubmit={handleSubmit} className={classes.form}>
                                        <div className={classes.input_data}>
                                            <FormControl className={classes.site} disabled={selectedRow.cli_id}>
                                                <InputLabel id="label-cliente">Cliente</InputLabel>
                                                <Select
                                                    labelId="label-cliente"
                                                    id="cliId"
                                                    name="cliId"
                                                    autoWidth
                                                    value={values.cliId}
                                                    onChange={async (event) => {
                                                        handleChange(event);
                                                        const { value } = event.target;
                                                        console.log("Veio aqui mesmo handleChange");
                                                        const respClienteLocal = await getClienteLocal(value);
                                                        setClientesLocal(respClienteLocal.data);
                                                    }}
                                                >
                                                    <MenuItem key="0" value="">
                                                        Nenhum...
                                                    </MenuItem>

                                                    {clientes.map((cliente) => (
                                                        <MenuItem
                                                            key={cliente.cli_id}
                                                            value={cliente.cli_id}
                                                        >
                                                            {cliente.cli_nome}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <FormControl className={classes.site}>
                                                <InputLabel id="label-cliente-local">Localidade</InputLabel>
                                                <Select
                                                    labelId="label-cliente-local"
                                                    id="locId"
                                                    name="locId"
                                                    autoWidth
                                                    value={values.locId}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem key="0" value="">
                                                        Nenhum...
                                                    </MenuItem>

                                                    {clientesLocal.map((clienteLocal) => (
                                                        <MenuItem
                                                            key={clienteLocal.loc_id}
                                                            value={clienteLocal.loc_id}
                                                        >
                                                            {clienteLocal.loc_nome}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <FormControl className={classes.site}>
                                                <InputLabel id="label-cliente-local">Algoritimo</InputLabel>
                                                <Select
                                                    labelId="label-cliente-algoritimo"
                                                    id="calId"
                                                    name="calId"
                                                    autoWidth
                                                    value={values.locId}
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem key="0" value="">
                                                        Nenhum...
                                                    </MenuItem>

                                                    {clientesLocal.map((listClienteAlgoritimo) => (
                                                        <MenuItem
                                                            key={listClienteAlgoritimo.cal_id}
                                                            value={listClienteAlgoritimo.cal_id}
                                                        >
                                                            {listClienteAlgoritimo.cal_id}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "flex-end",
                                                    marginTop: "1rem",
                                                }}
                                            >
                                                <ButtonSave
                                                    variant="contained"
                                                    size="small"
                                                    color="primary"
                                                    type="submit"
                                                    style={{
                                                        padding: "5px",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                    disabled={!isValid}
                                                >
                                                    Salvar
                                                </ButtonSave>
                                                <ButtonCancel
                                                    variant="contained"
                                                    color="primary"
                                                    type="button"
                                                    style={{
                                                        padding: "5px",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={cancelRecord}
                                                    disabled={inserir}
                                                >
                                                    Cancelar
                                                </ButtonCancel>

                                                <ButtonDelete
                                                    variant="contained"
                                                    color="primary"
                                                    type="button"
                                                    style={{
                                                        padding: "5px",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={deleteRecord}
                                                    disabled={inserir}
                                                >
                                                    Excluir
                                                </ButtonDelete>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        </div>
                    </Paper>
                </div>
            </DialogContent >
        </Dialog >
    );
};

